// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"9abc81be","389":"4efdc3d5","408":"2289932c","453":"141d864c","479":"7b36d7b6","699":"4a904656","778":"89cd492d","821":"0cec88ed"}[chunkId] + ".chunk.js";
};